import styled from 'styled-components'

export const Container = styled.div`
	padding: 24px 0;
`

export const ContainerRange = styled.div`
	padding-right: 21px;
`
